module.exports = __webpack_public_path__ + "static/img/2018.204a75c9.jpg";